'use strict';

require('../modules/forms/forms');

angular.module('far.forms.newsForm', ['dekky.forms'])
    .service('newsForm', function (form, fileUploadFilters, showModalMessage, NewsCategory, Committee, Discipline) {
        var newsForm = form('news');

        var errorMessages = [];

        newsForm
            .addField('disable_comments', 'checkbox', {
                validators: {
                    required: false
                },
                label: 'Отключить комментарии'
            })
            .addField('meta_title', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Meta title'
                }
            })
            .addField('meta_description', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Meta description'
                }
            })
            .addField('top', 'checkbox', {
                validators: {
                    required: false
                },
                label: 'TOP Новость'
            })
            .addField('homepage', 'checkbox', {
                validators: {
                    required: false
                },
                label: 'На главную'
            })
            .addField('accident', 'checkbox', {
                validators: {
                    required: false
                },
                label: 'Несчастный случай'
            })
            .addField('name', 'text', {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'Название новости'
                }
            })
            .addField('header', 'text', {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'Заголовок новости'
                }
            })
            .addField('committees', 'checkboxCollection', {
                checkbox: {
                    label: 'name',
                    model: 'selected'
                }},
            Committee.list)
            .addField('disciplines', 'checkboxCollection', {
                checkbox: {
                    label: 'name',
                    model: 'selected'
                }
            },Discipline.list)
            .addField('categories', 'checkboxCollection', {
                checkbox: {
                    label: 'name',
                    model: 'selected'
                }
            }, NewsCategory.list)
            .addField('created', 'dateDropdowns', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Дата публикации'
                }
            })
            .addField('brief', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Небольшой анонс',
                    maxlength: 140
                }
            })
            .addField('content', 'textarea', {
                validators: {
                    required: false
                },
                options: {
                    redactor: true,
                    placeholder: 'Основной текст'
                }
            })
            .addField('source', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Источник'
                }
            })
            .addField('youtube', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Youtube (ссылка)'
                }
            })
            .addField('avatar', 'imageUpload', {
                validators: {
                    required: false
                },
                uploader: {
                    url: Routing.generate('api_upload_post_avatar'),
                    autoUpload: true,
                    removeAfterUpload: true,
                    filters: [
                        fileUploadFilters.fileSize()
                    ],
                    onWhenAddingFileFailed: function (item, filter) {
                        var message = filter.message ? filter.message : 'Невозможно загрузить файл на сервер';
                        showModalMessage(message);
                    }
                }
            })
            .addField('slides_files', 'imageUpload', {
                validators: {
                    required: true
                },
                fieldData: {
                    multipleUpload: 'true'
                },
                label: 'Загрузить изображение',
                uploader: {
                    url: Routing.generate('api_upload_post_image'),
                    filters: [
                        fileUploadFilters.fileSize()
                    ],
                    autoUpload: true,
                    removeAfterUpload: true,
                    onWhenAddingFileFailed: function (item, filter) {
                        var message = filter.message ? filter.message : 'Невозможно загрузить файл на сервер';

                        if (errorMessages.indexOf(message) == -1) {
                            errorMessages.push(message);
                        }
                    },
                    onErrorItem: function () {
                        var message = 'Невозможно загрузить файл на сервер';

                        if (errorMessages.indexOf(message) == -1) {
                            errorMessages.push(message);
                        }
                    },
                    onCompleteAll: function () {
                        if (errorMessages.length > 0) {
                            showModalMessage(errorMessages.slice(0), 'Некоторые файлы не были загружены, т.к.:');
                            errorMessages = [];
                        }
                    }
                }
            })
            ;

        return newsForm;
    });
